"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consentPolicyApiFactory = void 0;
const viewer_service_session_manager_1 = require("@wix/viewer-service-session-manager");
const viewer_service_url_1 = require("@wix/viewer-service-url");
const signals_1 = require("@wix/services-manager/core-services/signals");
const utils_1 = require("./utils");
// load the consentPolicyManager script
require('@wix/cookie-consent-policy-client');
const consentPolicyApiFactory = (config, getService) => {
    const sessionManager = getService(viewer_service_session_manager_1.SessionManagerDefinition);
    const signalsService = getService(signals_1.SignalsServiceDefinition);
    const urlService = getService(viewer_service_url_1.UrlDefinition);
    const externalBaseUrl = urlService.externalBaseUrl;
    const window = globalThis.window;
    const updateCommonConfig = config.updateCommonConfig;
    const listeners = new Set();
    // @ts-expect-error - complains about 'Signal<Jsonifiable>' is not assignable to type 'Signal<PolicyDetails>'
    // - this occurs due to a usage of `Record`, with a custom key type (ConsentPolicyKey - which is a union of string keys) which typescript doesn't like being a key instead of type `string`
    const consentPolicySignal = signalsService.signal(
    // @ts-expect-error - complains about 'Signal<Jsonifiable>' is not assignable to type 'Signal<PolicyDetails>'
    // - this occurs due to a usage of `Record`, with a custom key type (ConsentPolicyKey - which is a union of string keys) which typescript doesn't like being a key instead of type `string`
    window.consentPolicyManager.getCurrentConsentPolicy());
    const api = {
        getCurrentConsentPolicy() {
            return consentPolicySignal.get();
        },
        _getConsentPolicyHeader() {
            return window.consentPolicyManager._getConsentPolicyHeader();
        },
        setConsentPolicy(policy) {
            return new Promise((resolve, reject) => {
                window.consentPolicyManager.setConsentPolicy(policy, resolve, reject);
            });
        },
        resetConsentPolicy() {
            window.consentPolicyManager.resetPolicy();
            consentPolicySignal.set(window.consentPolicyManager.getCurrentConsentPolicy());
            return Promise.resolve();
        },
        registerToChanges(listener) {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        publishPolicyUpdateRequestedEvent(cookieCategories = []) {
            window.consentPolicyManager.publishPolicyUpdateRequestedEvent(cookieCategories);
        },
    };
    const boundAccessTokenFunction = async () => {
        const appToken = sessionManager.getAppInstanceByAppDefId(utils_1.METASITE_APP_DEF_ID);
        return appToken || '';
    };
    const onConsentPolicyChanged = () => {
        const policyDetails = window.consentPolicyManager.getCurrentConsentPolicy();
        const policyHeaderObject = window.consentPolicyManager._getConsentPolicyHeader();
        updateCommonConfig &&
            updateCommonConfig({ consentPolicy: policyDetails.policy, consentPolicyHeader: policyHeaderObject });
        listeners.forEach(listener => listener(policyDetails, policyHeaderObject));
        consentPolicySignal.set(policyDetails);
    };
    window.document.addEventListener('consentPolicyChanged', onConsentPolicyChanged);
    window.document.addEventListener('consentPolicyInitialized', onConsentPolicyChanged);
    window.consentPolicyManager.init({
        baseUrl: externalBaseUrl,
        consentPolicy: config.siteConsentPolicy,
    }, boundAccessTokenFunction);
    updateCommonConfig &&
        updateCommonConfig({
            consentPolicy: window.consentPolicyManager.getCurrentConsentPolicy().policy,
            consentPolicyHeader: window.consentPolicyManager._getConsentPolicyHeader(),
        });
    return api;
};
exports.consentPolicyApiFactory = consentPolicyApiFactory;
//# sourceMappingURL=consentPolicyApiFactory.js.map